import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Images, MapPinOff } from "lucide-react";
import { api } from "@/lib/api";
import { useLiveRefresh } from "@/lib/live";
import { src } from "@/components/memories/MemoryParts";
import { SafeButton } from "@/components/location/ShareConfirm";

export function WhoStrip({ hub }) {
  const [d, setD] = useState(null);
  const load = useCallback(() => api.get(`/organizations/${hub.id}/checkins`).then(({ data }) => setD(data)).catch(() => setD(null)), [hub.id]);
  useEffect(() => { if (hub.my_access?.checkins) load(); }, [load, hub.my_access?.checkins]);
  useLiveRefresh(() => hub.my_access?.checkins && load(), (m) => m.entity === "checkin", 30000);
  if (!d || !hub.my_access?.checkins) return null;
  const rows = d.board.filter((r) => r.latest);
  return (
    <div className="mb-6 space-y-2">
    <div className="flex justify-end"><SafeButton hub={hub} locOn={d.my_location_on} onDone={load} testid="home-im-safe-btn" /></div>
    <Link to={`/h/${hub.id}/connect/whos-where`} className="q-card block p-4 transition-transform duration-150 hover:-translate-y-0.5" data-testid="home-whos-where-strip">
      <p className="q-label mb-2 flex items-center gap-2">Who's where <span className="inline-flex items-center gap-1 font-normal normal-case tracking-normal text-q-faint"><MapPinOff className="h-3 w-3" /> {d.note}</span></p>
      {!rows.length ? <p className="text-sm text-q-muted">No one has checked in yet. Tap to check in.</p> : (
        <div className="flex gap-4 overflow-x-auto pb-1">
          {rows.map((r) => (
            <div key={r.key} className="flex shrink-0 items-center gap-2" data-testid={`home-who-${r.key}`}>
              <span className={`text-2xl ${r.latest.stale ? "opacity-50 grayscale" : ""}`}>{r.latest.emoji}</span>
              <span className="text-sm"><span className={`font-semibold ${r.latest.stale ? "text-q-muted" : "text-q-text"}`}>{r.name.split(" ")[0]}</span><br /><span className={r.latest.stale ? "text-q-faint" : "text-q-muted"}>{r.latest.text || r.latest.label}</span></span>
            </div>
          ))}
        </div>
      )}
    </Link>
    </div>
  );
}

export function OnThisDay({ hub }) {
  const [d, setD] = useState(null);
  useEffect(() => { if (hub.my_access?.memories) api.get(`/organizations/${hub.id}/memories/on-this-day`).then(({ data }) => setD(data)).catch(() => {}); }, [hub.id, hub.my_access?.memories]);
  if (!d?.items?.length) return null;
  return (
    <Link to={`/h/${hub.id}/memories`} className="q-card mb-6 block p-4 transition-transform duration-150 hover:-translate-y-0.5" data-testid="home-on-this-day">
      <p className="q-label mb-2 flex items-center gap-2"><Images className="h-4 w-4" /> On this day <span className="font-normal normal-case tracking-normal text-q-muted" data-testid="on-this-day-label">· {d.label}</span></p>
      <div className="grid grid-cols-4 gap-1.5">{d.items.map((m) => <img key={m.id} src={src(m.thumb)} alt={m.caption || "Memory"} className="aspect-square w-full rounded-lg object-cover" />)}</div>
    </Link>
  );
}
